import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import useAuthenticatedData from '../hooks/useAuthenticatedData';
import { type } from '@testing-library/user-event/dist/type';

// Register the necessary Chart.js pieces
ChartJS.register(ArcElement, Tooltip, Legend);

const SalesRevenueGoal = () => {

  const formatFigure = (figure) => {
    /* if (figure >= 1_000_000) {
      return (figure / 1_000_000).toFixed(2) + 'M';
    }
    return Math.round(figure).toLocaleString();  */
    return Math.floor(figure).toLocaleString();
  };



  const options = {
    type: 'doughnut',
    rotation: 270,
    responsive: true,
    circumference: 180,
    maintainAspectRatio: true,
    responsive: true,
    animation: {
      duration: 0
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          color: 'white',
          font: {
            size: window.innerHeight * 0.018
          }
        },
      }
    }

  };

  // get the current month as MMM
  const monthNow = new Date().toLocaleString('default', { month: 'short' });

  //const { data, isLoading, error } = useAuthenticatedData('https://localhost:5001/monitor/sales-revenue-goal');
  const apiUrl = process.env.REACT_APP_CONTROL_API_URL;
  var url = apiUrl + 'monitor/sales-revenue-goal';
  const { data, isLoading, error } = useAuthenticatedData(url);

  if ((data != null) && (data.chartData != null)) {

    return (
      <div style={{ textAlign: 'center', backgroundColor: 'black' }}>
        <div className='col-sm-12 '>
          <p style={{ fontSize: '2.5vh', color: '#ffd240', margin: '0', fontWeight: 'bold' }}>SALES REVENUE GOAL</p>
        </div>
        <div className='row'>
          <div className='col-sm-6 '>
            <p style={{ fontSize: '3vh', color: 'white', margin: '0', fontWeight: 'bold' }}>{monthNow.toUpperCase()} SALES GOAL</p>
            <p style={{ fontSize: '1.8vh', color: '#bab8b8', margin: '0', fontWeight: 'bold' }}>(Sales revenue goal for current month)</p>
            <p style={{ fontSize: '3vh', color: 'white', margin: '0', fontWeight: 'bold' }}>${formatFigure(data.monthSalesGoal)}</p>
          </div>
          <div className='col-sm-6 '>
            <p style={{ fontSize: '3vh', color: 'white', margin: '0', fontWeight: 'bold' }}>OPEN SALES</p>
            <p style={{ fontSize: '1.8vh', color: '#bab8b8', margin: '0', fontWeight: 'bold' }}>(All sales orders with a ship date of this month)</p>
            <p style={{ fontSize: '3vh', color: 'white', margin: '0', fontWeight: 'bold' }}>${formatFigure(data.openSales)}</p>
          </div>
        </div>
        
        <div className='row'>
          <div className='col-sm-12 '>
            <Doughnut data={data.chartData} options={options} style={{ maxWidth: '100%', maxHeight: '25vh' }} />
          </div>
        </div>
        
        <div className='row'>
          <div className='col-sm-6 '>
            <p style={{ fontSize: '3vh', color: 'white', margin: '0', fontWeight: 'bold' }}>REVENUE</p>
            <p style={{ fontSize: '1.8vh', color: '#bab8b8', margin: '0', fontWeight: 'bold' }}>(All sales orders shipped out this month)</p>
            <p style={{ fontSize: '3vh', color: 'white', margin: '0', fontWeight: 'bold' }}>${formatFigure(data.revenue)}</p>
          </div>
          <div className='col-sm-6 '>
            <p style={{ fontSize: '3vh', color: 'white', margin: '0', fontWeight: 'bold' }}>CHASING</p>
            <p style={{ fontSize: '1.8vh', color: '#bab8b8', margin: '0', fontWeight: 'bold' }}>(Goal minus open sales & revenue)</p>
            <p style={{ fontSize: '3vh', color: 'white', margin: '0', fontWeight: 'bold' }}>${formatFigure(data.chasing)}</p>
          </div>
        </div>
      </div>
    );
  }


}

export default SalesRevenueGoal;
